import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { normalizeApiRole } from '@/lib/routing';
import { isRegistrationOnboardingComplete } from '@/lib/registrationSnapshot';
import { AuthLoadingFallback } from '@/components/auth/ProtectedRoute';

/** Blocks PEMOHON until onboarding (identitas usaha + Client snapshot) or payment verified. */
export function OnboardingGate({ children }) {
  const { user, authHydrated } = useApp();
  const location = useLocation();
  if (!authHydrated) return <AuthLoadingFallback />;
  if (normalizeApiRole(user.role) !== 'PEMOHON') return children;
  if (isRegistrationOnboardingComplete(user)) return children;
  if (location.pathname === '/onboarding') return children;
  return <Navigate to="/onboarding" replace />;
}

export default OnboardingGate;
